import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IProps {
    modelValue: boolean;
  }

  interface IEmits {
    (event: 'update:modelValue', modelValue: boolean) :void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: boolean) :void;
  }), expose: any, slots: any, attrs: any }) {

  
  

  function handleToggleChecked() {
    emits('update:modelValue', true);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radio", { active: __props.modelValue }]),
    onClick: handleToggleChecked
  }, null, 2))
}
}

})